import PalletModal from './PaletteModal';

export const PALETTE = 'PALETTE';
export const MODAL_SHARE_NOTE = 'MODAL_SHARE_NOTE';
export const MODAL_SHARE_REPORT = 'MODAL_SHARE_REPORT';

const modals = {
  [PALETTE]: PalletModal,
};

export default modals;
